import { render, staticRenderFns } from "./Stock-alerts.vue?vue&type=template&id=714ded69&"
import script from "./Stock-alerts.vue?vue&type=script&lang=js&"
export * from "./Stock-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports